import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 72 72"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M56.7 60.9 39.9 44.1c-1.5 1.2-3.225 2.15-5.175 2.85-1.95.7-4.025 1.05-6.225 1.05-5.45 0-10.063-1.888-13.838-5.663C10.887 38.563 9 33.95 9 28.5c0-5.45 1.887-10.063 5.662-13.838C18.438 10.887 23.05 9 28.5 9c5.45 0 10.063 1.887 13.837 5.662C46.112 18.438 48 23.05 48 28.5c0 2.2-.35 4.275-1.05 6.225-.7 1.95-1.65 3.675-2.85 5.175l16.875 16.875c.55.55.825 1.225.825 2.025 0 .8-.3 1.5-.9 2.1-.55.55-1.25.825-2.1.825-.85 0-1.55-.275-2.1-.825ZM28.5 42c3.75 0 6.938-1.313 9.563-3.938C40.687 35.438 42 32.25 42 28.5c0-3.75-1.313-6.938-3.938-9.563C35.438 16.313 32.25 15 28.5 15c-3.75 0-6.938 1.313-9.563 3.938C16.313 21.563 15 24.75 15 28.5c0 3.75 1.313 6.938 3.938 9.563C21.563 40.687 24.75 42 28.5 42Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "search"}) } }